import { AppLocale } from '../models/modules';
import huTrans from '../translations/hu.json';
import huTransFormal from '../translations/hu-formal.json';
import enTrans from '../translations/en.json';
import skTrans from '../translations/sk.json';
import deTrans from '../translations/de.json';
import deTransFormal from '../translations/de-formal.json';

export const translations = {
    [AppLocale.Hu]: huTrans,
    [AppLocale.HuFormal]: huTransFormal,
    [AppLocale.En]: enTrans,
    [AppLocale.Sk]: skTrans,
    [AppLocale.De]: deTrans,
    [AppLocale.DeFormal]: deTransFormal,
};

export const apiLanguages = {
    [AppLocale.Hu]: 'hu',
    [AppLocale.HuFormal]: 'yo-NG',
    [AppLocale.En]: 'en-US',
    [AppLocale.Sk]: 'sk-SK',
    [AppLocale.De]: 'de-AT',
    [AppLocale.DeFormal]: 'de-DE',
};